module.exports = __webpack_public_path__ + "img/pic_australia_03.84466e63.jpg";